// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3ChXn","info":"UpdateTermsInfo_info__2cxkN"};